import { useSelector } from "react-redux";

// Page sections
import MapTab from "../MapTab";
import TgAttrListingSection from "./TgAttrListingSection";
import SelectedTgAttrForRankingSection from "./SelectedTgAttrForRankingSection";

// constants
const selectedViewLabels = {
  header: {
    title: "Area Ranking",
    changeViewBtnText: "Add TG Attributes",
  },
  body: {
    emptyText: "Add TG Attributes",
    emptyIconCls: "fas fa-border-style",
  },
};

const listingViewLabels = {
  header: {
    title: "TG Attributes",
    createBtnText: "",
    createBtnUrl: "",
  },
};

/**
 * TAB - PINCODE RANKING
 */
export default function PincodeRankingTab({ cityId }) {
  // applied TG Attr Map for Ranking
  const appliedTgAttrMapForRanking = useSelector(
    (state) => state.region.appliedTgAttrMapForRanking
  );

  // getting content for "selectedViewContent"
  function checkForSelectedViewContent() {
    if (Object.keys(appliedTgAttrMapForRanking).length === 0) {
      return null;
    }

    return (
      <SelectedTgAttrForRankingSection
        appliedTgAttrMapForRanking={appliedTgAttrMapForRanking}
      />
    );
  }

  // Selected View :: Body
  const selectedViewContent = checkForSelectedViewContent();

  // Listing View :: Body
  const listingViewContent = <TgAttrListingSection cityId={cityId} />;

  // Tab Rendered Content ------------------------------------
  return (
    <MapTab
      selectedViewLabels={selectedViewLabels}
      selectedViewChildren={selectedViewContent}
      listingViewLabels={listingViewLabels}
      listingViewChildren={listingViewContent}
    />
  );
}
